import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import React from 'react'

interface RateSheetTypeTooltipProps {
    isProvisional: boolean
}

const RateSheetTypeTooltip = ({ isProvisional }: RateSheetTypeTooltipProps) => (
    <CustomToolTip
        type="i"
        inverse
        place="left"
        info={
            <>
                {isProvisional ? (
                    <p>
                        <strong>Provisional rate sheets</strong> are subject to change upon The MLC&apos;s completion of
                        processing of corresponding usage files. The MLC will provide final royalty statement rate
                        calculation sheets after such processing, which may supersede these provisional sheets and may
                        contain different figures.
                    </p>
                ) : (
                    <>
                        <p>
                            <strong>Current rate sheets</strong> are the final royalty statement rate calculation for
                            this DSP and usage period.
                        </p>
                        <br />
                        <p>
                            <strong>Original rate sheets</strong> are the initial rate sheet before a later adjusted
                            usage file is delivered to The MLC. Original rate sheets are no longer valid, but remain
                            visible to compare to the current rate sheet for transparency. *NOTE: Not every DSP and
                            usage period will have an original rate sheet; these only occur if an adjustment was needed
                            to an initial rate sheet.
                        </p>
                        <br />
                    </>
                )}
            </>
        }
    />
)
export default RateSheetTypeTooltip
